'use strict';

var component = angular.module('saturn.layout.nav.page', [
  'ngAnimate'
]);

var PageDirective = require('./PageDirective');
var PageController = require('./PageController');

component.controller('sbNavDrawerPageController', [
  '$scope',
  'sbNavDrawerService',
  PageController
]);

component.directive('sbNavDrawerPage', [
  '$animate',
  PageDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/page/index.js